import React from 'react'
import { UseFormReturn } from 'react-hook-form';
import TextEditor from '../../../FormEditors/TextEditor';
import { MasterMedicine } from '../../../../apis/master-medicines/types';

interface MasterMedicineNameEditorProps {
  form: UseFormReturn<MasterMedicine>;
}

const MasterMedicineNameEditor = ({ form }: MasterMedicineNameEditorProps) => {
  return <TextEditor label="Master medicine name" control={form.control} name="name" />;
};

export default MasterMedicineNameEditor;
